/**
 * Shared page shell for master screens.
 * Provides: title/subtitle, primary CTA, search, and body container.
 * Every master screen composes its own table + dialog inside `children`.
 */
export const PageShell = ({
  eyebrow,
  title,
  subtitle,
  primaryAction,
  filters,
  children,
  testId,
}) => {
  return (
    <main className="mx-auto max-w-[1400px] px-6 py-8" data-testid={testId}>
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4 vision-rise">
        <div>
          {eyebrow && (
            <div className="text-xs font-semibold uppercase tracking-[0.16em] text-vision-slate/60">
              {eyebrow}
            </div>
          )}
          <h1 className="mt-1 font-display text-3xl font-extrabold text-vision-ink sm:text-4xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-vision-slate/70">{subtitle}</p>
          )}
        </div>
        {primaryAction}
      </div>

      {filters && (
        <div className="mb-4 flex flex-wrap items-center gap-3 vision-rise vision-rise-d1">
          {filters}
        </div>
      )}

      <div className="vision-rise vision-rise-d2">{children}</div>
    </main>
  );
};

export default PageShell;
